import Swiper from './swiper';

/** @deprecated */
export default Swiper;
